import React from "react";
import Head from "next/head";
import Script from "next/script";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var Polyfills = function Polyfills() {
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Head, null, ___EmotionJSX("link", {
    rel: "preload",
    as: "script",
    href: "https://polyfill.io/v3/polyfill.min.js?features=NodeList.prototype.%40%40iterator%2CElement.prototype.closest%2CglobalThis%2ClocalStorage%2CSymbol.toStringTag%2CElement.prototype.prepend%2Csmoothscroll%2CIntersectionObserver&flags=gated",
    crossOrigin: "anonymous"
  })), ___EmotionJSX(Script, {
    crossOrigin: "anonymous",
    src: "https://polyfill.io/v3/polyfill.min.js?features=NodeList.prototype.%40%40iterator%2CElement.prototype.closest%2CglobalThis%2ClocalStorage%2CSymbol.toStringTag%2CElement.prototype.prepend%2Csmoothscroll%2CIntersectionObserver&flags=gated"
  }));
};